import { useState } from 'react';
import { useNavigate } from 'react-router';
import { X } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { useOnboardingStore } from '@/stores/onboardingStore';
import { IconButton } from '@/components/ui/IconButton';

const DISMISS_KEY = 'brainday:nudge-dismissed-at';
const RESHOW_DAYS = 7;

function isDismissedRecently(): boolean {
  const raw = localStorage.getItem(DISMISS_KEY);
  if (!raw) return false;
  const dismissed = Number(raw);
  return Date.now() - dismissed < RESHOW_DAYS * 86_400_000;
}

export function SignInNudgeBanner() {
  const authMode = useAuthStore((s) => s.authMode);
  const hasSeenAuth = useOnboardingStore((s) => s.hasSeenAuthPrompt);
  const [dismissed, setDismissed] = useState(isDismissedRecently);
  const navigate = useNavigate();

  if (authMode === 'authenticated' || !hasSeenAuth || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setDismissed(true);
  };

  return (
    <div className="flex items-center justify-between gap-3 border-b border-line-2 bg-elev px-4 py-2">
      <p className="text-xs text-t2">
        Your data lives on this device only. Sign in to keep it safe.
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={() => void navigate('/login')}
          className="whitespace-nowrap rounded text-xs font-medium text-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
        >
          Sign in
        </button>
        <IconButton
          label="Dismiss"
          icon={<X className="h-3.5 w-3.5" />}
          variant="ghost"
          size="sm"
          onClick={handleDismiss}
        />
      </div>
    </div>
  );
}
